<div class="admin-detail-page">
  <div class="page-header">
    <button nz-button nzType="default" routerLink="/admin/sign-orders" class="back-button">
      <i nz-icon nzType="arrow-left"></i>
      {{ 'SIGN_ORDER.ADMIN.BACK_TO_LIST' | translate }}
    </button>
  </div>

  <nz-alert *ngIf="errorMessage" nzType="error" [nzMessage]="errorMessage" nzShowIcon></nz-alert>
  <nz-alert *ngIf="pdfErrorMessage" nzType="error" [nzMessage]="pdfErrorMessage" nzShowIcon nzClosable (nzOnClose)="pdfErrorMessage = null" class="pdf-error"></nz-alert>

  <nz-spin [nzSpinning]="isLoading">
    <ng-container *ngIf="order">
      <div class="order-header">
        <h1>{{ 'SIGN_ORDER.ADMIN.DETAIL_TITLE' | translate:{ orderNumber: order.orderNumber } }}</h1>
        <nz-tag [nzColor]="getStatusColor(order.status)" class="status-tag">
          {{ getStatusLabel(order.status) }}
        </nz-tag>
      </div>

      <div class="action-bar" *ngIf="allowedTransitions.length">
        <button nz-button nzType="default" nzSize="small"
          *ngIf="order.status === 'pending_payment'"
          (click)="openInvoiceNumberModal()">
          {{ (hasInvoiceNumber ? 'SIGN_ORDER.ADMIN.UPDATE_INVOICE_NUMBER' : 'SIGN_ORDER.ADMIN.RECORD_INVOICE_NUMBER') | translate }}
        </button>
        <button nz-button nzType="primary" nzSize="small"
          *ngFor="let t of allowedTransitions"
          [nzLoading]="isSubmittingAction"
          [disabled]="isSubmittingAction || (t === 'payment_received' && !hasInvoiceNumber)"
          [nz-tooltip]="t === 'payment_received' && !hasInvoiceNumber ? ('SIGN_ORDER.ADMIN.INVOICE_NUMBER_REQUIRED_BEFORE_PAYMENT' | translate) : null"
          (click)="transitionTo(t)">
          {{ 'SIGN_ORDER.ADMIN.ACTION_' + t.toUpperCase() | translate }}
        </button>
        <button nz-button nzType="default" nzSize="small" (click)="saveNotes()">
          <i nz-icon nzType="save"></i>
          {{ 'SIGN_ORDER.ADMIN.SAVE_NOTES' | translate }}
        </button>
      </div>

      <div class="notes-section">
        <div class="notes-row">
          <label>{{ 'SIGN_ORDER.ADMIN.INTERNAL_NOTES' | translate }}:</label>
          <textarea nz-input [(ngModel)]="order.internalNotes" rows="2" style="width:100%"></textarea>
        </div>
        <div class="notes-row">
          <label>{{ 'SIGN_ORDER.ADMIN.USER_NOTE' | translate }}:</label>
          <textarea nz-input [(ngModel)]="order.userVisibleNote" rows="2" style="width:100%"></textarea>
        </div>
      </div>

      <div class="detail-grid">
        <nz-card [nzTitle]="'SIGN_ORDER.ADMIN.SECTION_ORDER' | translate">
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.ORDER_NUMBER' | translate }}</span>
            <span class="info-value"><code>{{ order.orderNumber }}</code></span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.CREATED_AT' | translate }}</span>
            <span class="info-value">{{ formatSignOrderDateTime(order.createdAt, translate.currentLang) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.COMPANY' | translate }}</span>
            <span class="info-value">{{ order.company?.name }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.REQUESTER_NAME' | translate }}</span>
            <span class="info-value">{{ order.requester?.displayName }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.REQUESTER_EMAIL' | translate }}</span>
            <span class="info-value">{{ order.requester?.email }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.REQUEST_LOCALE' | translate }}</span>
            <span class="info-value">{{ order.requestLocale }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.STATUS' | translate }}</span>
            <span class="info-value"><nz-tag [nzColor]="getStatusColor(order.status)">{{ getStatusLabel(order.status) }}</nz-tag></span>
          </div>
          <div class="info-row" *ngIf="order.paidAt">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.PAID_AT' | translate }}</span>
            <span class="info-value">{{ formatSignOrderDateTime(order.paidAt, translate.currentLang) }}</span>
          </div>
          <div class="info-row" *ngIf="order.shippedAt">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.SHIPPED_AT' | translate }}</span>
            <span class="info-value">{{ formatSignOrderDateTime(order.shippedAt, translate.currentLang) }}</span>
          </div>
          <ng-container *ngIf="order.shipment?.carrier || order.shipment?.trackingNumber || order.shipment?.trackingUrl || order.shipment?.note?.trim()">
            <div class="info-row" *ngIf="order.shipment?.carrier">
              <span class="info-label">{{ 'SIGN_ORDER.ADMIN.SHIP_CARRIER' | translate }}</span>
              <span class="info-value">{{ order.shipment?.carrier }}</span>
            </div>
            <div class="info-row" *ngIf="order.shipment?.trackingNumber">
              <span class="info-label">{{ 'SIGN_ORDER.ADMIN.SHIP_TRACKING' | translate }}</span>
              <span class="info-value">{{ order.shipment?.trackingNumber }}</span>
            </div>
            <div class="info-row" *ngIf="order.shipment?.trackingUrl">
              <span class="info-label">URL</span>
              <span class="info-value"><a [href]="order.shipment?.trackingUrl" target="_blank">{{ order.shipment?.trackingUrl }}</a></span>
            </div>
            <div class="info-row" *ngIf="order.shipment?.note?.trim()">
              <span class="info-label">{{ 'SIGN_ORDER.ADMIN.SHIP_NOTE' | translate }}</span>
              <span class="info-value shipment-note-value">{{ order.shipment?.note }}</span>
            </div>
          </ng-container>
          <div class="info-row" *ngIf="order.completedAt">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.COMPLETED_AT' | translate }}</span>
            <span class="info-value">{{ formatSignOrderDateTime(order.completedAt, translate.currentLang) }}</span>
          </div>
          <div class="info-row" *ngIf="order.cancelledAt">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.CANCELLED_AT' | translate }}</span>
            <span class="info-value">{{ formatSignOrderDateTime(order.cancelledAt, translate.currentLang) }}</span>
          </div>
        </nz-card>

        <nz-card [nzTitle]="'SIGN_ORDER.ADMIN.SECTION_COMMERCIAL' | translate">
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.PRODUCT' | translate }}</span>
            <span class="info-value">{{ localizedText(order.productSnapshot?.name) }} ({{ order.productSnapshot?.material }}, {{ order.productSnapshot?.format }})</span>
          </div>
          <div class="info-row" *ngIf="order.pricingSnapshot?.selectedSignTier as selectedSignTier">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.SIGN_PRICING_TIER' | translate }}</span>
            <span class="info-value">{{ formatTierRange(selectedSignTier) }}</span>
          </div>
          <div class="info-row" *ngIf="order.pricingSnapshot?.selectedShippingTier as selectedShippingTier">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.SHIPPING_TIER' | translate }}</span>
            <span class="info-value">{{ formatTierRange(selectedShippingTier) }}</span>
          </div>
          <div class="info-row" *ngIf="order.pricingSnapshot">
            <span class="info-label">{{ 'SIGN_ORDER.CHECKOUT.DRILLING_OPTION' | translate }}</span>
            <span class="info-value">{{ 'SIGN_ORDER.CHECKOUT.DRILLING_' + order.pricingSnapshot.drillingOption.toUpperCase() | translate }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.ORDER_BASE_UNIT_PRICE' | translate }}</span>
            <span class="info-value">{{ formatCents(order.pricingSnapshot?.baseUnitNetCents || 0, order.currency) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.ORDER_DRILLING_UNIT_PRICE' | translate }}</span>
            <span class="info-value">{{ formatCents(order.pricingSnapshot?.drillingUnitNetCents || 0, order.currency) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.COMBINED_UNIT_PRICE' | translate }}</span>
            <span class="info-value">{{ formatCents(order.pricingSnapshot?.combinedUnitNetCents || 0, order.currency) }}</span>
          </div>
          <nz-divider></nz-divider>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.BASE_SIGNS_SUBTOTAL' | translate }}</span>
            <span class="info-value">{{ formatCents(order.baseSignsNetSubtotalCents, order.currency) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.DRILLING_SUBTOTAL' | translate }}</span>
            <span class="info-value">{{ formatCents(order.drillingNetSubtotalCents, order.currency) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.SIGNS_SUBTOTAL' | translate }}</span>
            <span class="info-value">{{ formatCents(order.signsNetSubtotalCents, order.currency) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.SHIPPING' | translate }}</span>
            <span class="info-value">{{ formatCents(order.shippingNetCents, order.currency) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.UNIT_WEIGHT' | translate }}</span>
            <span class="info-value">{{ formatSignOrderWeight(order.unitWeightGrams, translate.currentLang) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.TOTAL_WEIGHT' | translate }}</span>
            <span class="info-value">{{ formatSignOrderWeight(order.totalWeightGrams, translate.currentLang) }}</span>
          </div>
          <nz-divider></nz-divider>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.TAXABLE_NET' | translate }}</span>
            <span class="info-value">{{ formatCents(order.taxableNetCents, order.currency) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.VAT' | translate }} ({{ formatVatRate(order.vatRateBasisPoints) }})</span>
            <span class="info-value">{{ formatCents(order.vatAmountCents, order.currency) }}</span>
          </div>
          <div class="info-row total-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.GROSS_TOTAL' | translate }}</span>
            <span class="info-value">{{ formatCents(order.grossTotalCents, order.currency) }}</span>
          </div>
          <nz-divider></nz-divider>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.PAYMENT_REFERENCE' | translate }}</span>
            <span class="info-value"><code>{{ order.paymentReference }}</code></span>
          </div>
          <div class="info-row" *ngIf="order.invoiceNumber?.trim()">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.INVOICE_NUMBER' | translate }}</span>
            <span class="info-value"><code>{{ order.invoiceNumber }}</code></span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.RECIPIENT' | translate }}</span>
            <span class="info-value">{{ order.paymentInstructionsSnapshot?.recipient }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.IBAN' | translate }}</span>
            <span class="info-value"><code>{{ order.paymentInstructionsSnapshot?.iban }}</code></span>
          </div>
        </nz-card>

        <nz-card [nzTitle]="'SIGN_ORDER.ADMIN.SECTION_SHIPPING' | translate">
          <p>{{ order.shippingAddressSnapshot?.companyName }}</p>
          <p>{{ order.shippingAddressSnapshot?.contactName }}</p>
          <p>{{ order.shippingAddressSnapshot?.street }} {{ order.shippingAddressSnapshot?.houseNumber }}</p>
          <p *ngIf="order.shippingAddressSnapshot?.addressLine2">{{ order.shippingAddressSnapshot.addressLine2 }}</p>
          <p>{{ order.shippingAddressSnapshot?.postalCode }} {{ order.shippingAddressSnapshot?.city }}</p>
          <p>{{ translate.currentLang === 'de' ? 'Deutschland' : 'Germany' }}</p>
          <p>{{ order.shippingAddressSnapshot?.email }}</p>
          <p *ngIf="order.shippingAddressSnapshot?.phone">{{ order.shippingAddressSnapshot.phone }}</p>
        </nz-card>

        <nz-card [nzTitle]="'SIGN_ORDER.ADMIN.SECTION_BILLING' | translate">
          <p *ngIf="order.billingAddressSameAsShipping">{{ 'SIGN_ORDER.ADMIN.BILLING_SAME_AS_SHIPPING' | translate }}</p>
          <ng-container>
            <p>{{ order.billingAddressSnapshot?.companyName }}</p>
            <p>{{ order.billingAddressSnapshot?.contactName }}</p>
            <p>{{ order.billingAddressSnapshot?.street }} {{ order.billingAddressSnapshot?.houseNumber }}</p>
            <p *ngIf="order.billingAddressSnapshot?.addressLine2">{{ order.billingAddressSnapshot.addressLine2 }}</p>
            <p>{{ order.billingAddressSnapshot?.postalCode }} {{ order.billingAddressSnapshot?.city }}</p>
            <p>{{ translate.currentLang === 'de' ? 'Deutschland' : 'Germany' }}</p>
          </ng-container>
        </nz-card>

        <nz-card [nzTitle]="'SIGN_ORDER.ADMIN.SECTION_PROPERTIES' | translate">
          <div class="section-summary">
            <p>{{ 'SIGN_ORDER.ADMIN.UNIQUE_PROPERTIES' | translate }}: <strong>{{ order.items?.length || 0 }}</strong></p>
            <p>{{ 'SIGN_ORDER.ADMIN.TOTAL_COPIES' | translate }}: <strong>{{ order.pricingSnapshot?.totalQuantity || 0 }}</strong></p>
          </div>
          <nz-table #adminOrderItemsTable [nzData]="orderItems" nzSize="small" [nzPageSize]="20">
            <thead>
              <tr>
                <th>{{ 'SIGN_ORDER.ADMIN.PROPERTY_IDENTIFIER' | translate }}</th>
                <th>{{ 'SIGN_ORDER.ADMIN.PROPERTY_ADDRESS' | translate }}</th>
                <th>{{ 'SIGN_ORDER.ADMIN.COPIES' | translate }}</th>
                <th>{{ 'SIGN_ORDER.ADMIN.ACTIONS' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of adminOrderItemsTable.data">
                <td>{{ item.identifier }}</td>
                <td>{{ item.address }}</td>
                <td>{{ item.copies }}</td>
                <td>
                  <button nz-button nzType="default" nzSize="small"
                    [nzLoading]="isItemGenerating(item)"
                    (click)="previewItem(item)">
                    <i nz-icon nzType="eye"></i>
                    {{ 'SIGN_ORDER.ADMIN.PREVIEW' | translate }}
                  </button>
                  <button nz-button nzType="default" nzSize="small"
                    [nzLoading]="isItemGenerating(item)"
                    (click)="downloadIndividualPdf(item)">
                    <i nz-icon nzType="file-pdf"></i>
                    {{ 'SIGN_ORDER.ADMIN.DOWNLOAD_PDF' | translate }}
                  </button>
                </td>
              </tr>
            </tbody>
          </nz-table>
          <div class="section-actions">
            <button nz-button nzType="primary"
              [nzLoading]="isGeneratingCombinedPdf"
              (click)="downloadCombinedPdf()">
              <i nz-icon nzType="file-pdf"></i>
              {{ 'SIGN_ORDER.ADMIN.DOWNLOAD_COMBINED_PDF' | translate }}
            </button>
            <span class="combined-hint" *ngIf="order.items?.length">
              {{ 'SIGN_ORDER.ADMIN.COMBINED_PDF_HINT' | translate:{ pages: getCombinedPdfPages() } }}
            </span>
          </div>
        </nz-card>

        <nz-card *ngIf="order.statusHistory?.length" [nzTitle]="'SIGN_ORDER.ADMIN.SECTION_STATUS_HISTORY' | translate">
          <nz-timeline>
            <nz-timeline-item *ngFor="let entry of order.statusHistory"
              [nzColor]="getStatusColor(entry.nextStatus)">
              <p class="timeline-title">{{ getStatusLabel(entry.nextStatus) }}</p>
              <p class="timeline-date">{{ formatSignOrderDateTime(entry.changedAt, translate.currentLang) }}</p>
              <p class="timeline-actor" *ngIf="entry.actor?.displayName">{{ entry.actor?.displayName }} ({{ entry.actor?.role }})</p>
              <p class="timeline-reason" *ngIf="entry.reason">{{ entry.reason }}</p>
            </nz-timeline-item>
          </nz-timeline>
        </nz-card>

        <nz-card *ngIf="order.emailEvents?.length" [nzTitle]="'SIGN_ORDER.ADMIN.SECTION_EMAILS' | translate">
          <nz-table [nzData]="order.emailEvents" [nzShowPagination]="false" nzSize="small">
            <thead>
              <tr>
                <th>{{ 'SIGN_ORDER.ADMIN.EMAIL_TYPE' | translate }}</th>
                <th>{{ 'SIGN_ORDER.ADMIN.EMAIL_RECIPIENT' | translate }}</th>
                <th>{{ 'SIGN_ORDER.ADMIN.EMAIL_STATUS' | translate }}</th>
                <th>{{ 'SIGN_ORDER.ADMIN.EMAIL_ATTEMPTS' | translate }}</th>
                <th>{{ 'SIGN_ORDER.ADMIN.EMAIL_LAST_ERROR' | translate }}</th>
                <th>{{ 'SIGN_ORDER.ADMIN.ACTIONS' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let evt of order.emailEvents">
                <td>{{ evt.eventType }}</td>
                <td>{{ evt.recipient }}</td>
                <td><nz-tag [nzColor]="evt.status === 'sent' ? 'green' : evt.status === 'failed' ? 'red' : 'blue'">{{ evt.status }}</nz-tag></td>
                <td>{{ evt.attempts }}</td>
                <td style="max-width:200px;overflow:hidden;text-overflow:ellipsis" [nz-tooltip]="evt.lastError">{{ evt.lastError }}</td>
                <td>
                  <button nz-button nzSize="small" nzDanger *ngIf="evt.status === 'failed'" [nzLoading]="isRetryingEmail" (click)="retryEmail(evt.eventKey)">
                    {{ 'SIGN_ORDER.ADMIN.RETRY' | translate }}
                  </button>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </nz-card>

        <nz-card *ngIf="order.legalAcceptanceSnapshot" [nzTitle]="'SIGN_ORDER.ADMIN.LEGAL_ACCEPTANCE' | translate">
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.ACCEPTED_AT' | translate }}</span>
            <span class="info-value">{{ formatSignOrderDateTime(order.legalAcceptanceSnapshot.acceptedAt, translate.currentLang) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.ACCEPTED_BY' | translate }}</span>
            <span class="info-value">{{ order.legalAcceptanceSnapshot.acceptedByName }} ({{ order.legalAcceptanceSnapshot.acceptedByEmail }})</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.REQUEST_LOCALE' | translate }}</span>
            <span class="info-value">{{ order.legalAcceptanceSnapshot.requestLocale }}</span>
          </div>
          <nz-divider></nz-divider>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.CONFIRM_BUSINESS' | translate }}</span>
            <span class="info-value"><nz-tag [nzColor]="order.legalAcceptanceSnapshot.businessOrderConfirmed && order.legalAcceptanceSnapshot.orderingAuthorityConfirmed ? 'green' : 'red'">{{ (order.legalAcceptanceSnapshot.businessOrderConfirmed && order.legalAcceptanceSnapshot.orderingAuthorityConfirmed ? 'SIGN_ORDER.ADMIN.YES' : 'SIGN_ORDER.ADMIN.NO') | translate }}</nz-tag></span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.CONFIRM_CONTENT' | translate }}</span>
            <span class="info-value"><nz-tag [nzColor]="order.legalAcceptanceSnapshot.contentRightsConfirmed ? 'green' : 'red'">{{ (order.legalAcceptanceSnapshot.contentRightsConfirmed ? 'SIGN_ORDER.ADMIN.YES' : 'SIGN_ORDER.ADMIN.NO') | translate }}</nz-tag></span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.CONFIRM_SNAPSHOT' | translate }}</span>
            <span class="info-value"><nz-tag [nzColor]="order.legalAcceptanceSnapshot.printSnapshotApproved ? 'green' : 'red'">{{ (order.legalAcceptanceSnapshot.printSnapshotApproved ? 'SIGN_ORDER.ADMIN.YES' : 'SIGN_ORDER.ADMIN.NO') | translate }}</nz-tag></span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.CONFIRM_TERMS' | translate }}</span>
            <span class="info-value"><nz-tag [nzColor]="order.legalAcceptanceSnapshot.signOrderTermsAccepted && order.legalAcceptanceSnapshot.generalTermsAccepted ? 'green' : 'red'">{{ (order.legalAcceptanceSnapshot.signOrderTermsAccepted && order.legalAcceptanceSnapshot.generalTermsAccepted ? 'SIGN_ORDER.ADMIN.YES' : 'SIGN_ORDER.ADMIN.NO') | translate }}</nz-tag></span>
          </div>
          <nz-divider></nz-divider>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.SIGN_ORDER_TERMS_URL' | translate }}</span>
            <span class="info-value"><a [href]="order.legalAcceptanceSnapshot.signOrderTermsUrl" target="_blank" rel="noopener noreferrer">{{ order.legalAcceptanceSnapshot.signOrderTermsUrl }}</a></span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.GENERAL_TERMS_URL' | translate }}</span>
            <span class="info-value"><a [href]="order.legalAcceptanceSnapshot.generalTermsUrl" target="_blank" rel="noopener noreferrer">{{ order.legalAcceptanceSnapshot.generalTermsUrl }}</a></span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.PRIVACY_URL' | translate }}</span>
            <span class="info-value"><a [href]="order.legalAcceptanceSnapshot.privacyNoticeUrl" target="_blank" rel="noopener noreferrer">{{ order.legalAcceptanceSnapshot.privacyNoticeUrl }}</a></span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'SIGN_ORDER.ADMIN.LEGAL_NOTICE_URL' | translate }}</span>
            <span class="info-value"><a [href]="order.legalAcceptanceSnapshot.legalNoticeUrl" target="_blank" rel="noopener noreferrer">{{ order.legalAcceptanceSnapshot.legalNoticeUrl }}</a></span>
          </div>
        </nz-card>

        <nz-card *ngIf="order.internalNotes" [nzTitle]="'SIGN_ORDER.ADMIN.INTERNAL_NOTES' | translate">
          <pre class="notes-text">{{ order.internalNotes }}</pre>
        </nz-card>

        <nz-card *ngIf="order.userVisibleNote" [nzTitle]="'SIGN_ORDER.ADMIN.USER_NOTE' | translate">
          <p>{{ order.userVisibleNote }}</p>
        </nz-card>
      </div>
    </ng-container>
  </nz-spin>

  <nz-modal [(nzVisible)]="cancelModalVisible" [nzTitle]="'SIGN_ORDER.ADMIN.CANCEL_TITLE' | translate" [nzOkLoading]="isSubmittingAction" (nzOnOk)="submitCancellation()" (nzOnCancel)="cancelModalVisible = false">
    <ng-container *nzModalContent>
      <p>{{ 'SIGN_ORDER.ADMIN.CANCEL_REASON' | translate }}</p>
      <textarea nz-input [(ngModel)]="cancelReason" rows="3" style="width:100%"></textarea>
    </ng-container>
  </nz-modal>

  <nz-modal [(nzVisible)]="shipmentModalVisible" [nzTitle]="'SIGN_ORDER.ADMIN.SHIP_TITLE' | translate" [nzOkLoading]="isSubmittingAction" (nzOnOk)="submitShipment()" (nzOnCancel)="shipmentModalVisible = false">
    <ng-container *nzModalContent>
      <div style="display:flex;flex-direction:column;gap:12px">
        <div>
          <label style="display:block;margin-bottom:4px;font-size:13px;font-weight:500">{{ 'SIGN_ORDER.ADMIN.SHIP_CARRIER' | translate }}</label>
          <input nz-input [(ngModel)]="shipCarrier" />
        </div>
        <div>
          <label style="display:block;margin-bottom:4px;font-size:13px;font-weight:500">{{ 'SIGN_ORDER.ADMIN.SHIP_TRACKING' | translate }}</label>
          <input nz-input [(ngModel)]="shipTracking" />
        </div>
        <div>
          <label style="display:block;margin-bottom:4px;font-size:13px;font-weight:500">Tracking URL</label>
          <input nz-input [(ngModel)]="shipUrl" />
        </div>
        <div>
          <label style="display:block;margin-bottom:4px;font-size:13px;font-weight:500">{{ 'SIGN_ORDER.ADMIN.SHIP_NOTE_VISIBLE_TO_CUSTOMER' | translate }}</label>
          <input nz-input [(ngModel)]="shipNote" />
        </div>
      </div>
    </ng-container>
  </nz-modal>

  <nz-modal
    [(nzVisible)]="invoiceNumberModalVisible"
    [nzTitle]="(hasInvoiceNumber ? 'SIGN_ORDER.ADMIN.UPDATE_INVOICE_NUMBER' : 'SIGN_ORDER.ADMIN.RECORD_INVOICE_NUMBER') | translate"
    [nzOkLoading]="isSavingInvoiceNumber"
    [nzClosable]="!isSavingInvoiceNumber"
    [nzMaskClosable]="!isSavingInvoiceNumber"
    (nzOnOk)="submitInvoiceNumber()"
    (nzOnCancel)="closeInvoiceNumberModal()">
    <ng-container *nzModalContent>
      <div style="display:flex;flex-direction:column;gap:8px">
        <label style="display:block;font-size:13px;font-weight:500">{{ 'SIGN_ORDER.ADMIN.INVOICE_NUMBER' | translate }}</label>
        <input
          nz-input
          [(ngModel)]="invoiceNumberDraft"
          [placeholder]="'SIGN_ORDER.ADMIN.INVOICE_NUMBER_PLACEHOLDER' | translate"
          maxlength="120" />
        <p style="margin:0;color:#6b7280;font-size:13px">{{ 'SIGN_ORDER.ADMIN.INVOICE_NUMBER_HELPER' | translate }}</p>
        <p *ngIf="invoiceNumberValidationError" style="margin:0;color:#dc2626;font-size:13px">{{ invoiceNumberValidationError }}</p>
      </div>
    </ng-container>
  </nz-modal>
</div>
